export enum BuyingProbability {
  one = '1',
  two = '2',
  three = '3'
}
